// extracted by mini-css-extract-plugin
export var deliveryRow = "_td-a";
export var fixedHeight = "_td-4";
export var freightLogo = "_td-9";
export var fullWidth = "_td-3";
export var priceColumn = "_td-5";
export var radioSelected = "_td-7";
export var radioUnselected = "_td-6";
export var selectedOption = "_td-2";
export var selectedOptionContainer = "_td-1";
export var selection = "_td-0";
export var tallSkeletonText = "_td-8";